import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BRIEF_LIST_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useAttachReport() {
  const {
    mutate: attachReport,
    isLoading: isAttaching,
    isSuccess: isAttached,
    variables,
  } = useMutation({
    mutationFn: ({
      briefId,
      updateForIntervalHourFrequency,
      updateTillDate,
    }: {
      briefId: string;
      updateForIntervalHourFrequency: number;
      updateTillDate: string;
    }) =>
      BriefService.attachReport(
        briefId,
        updateForIntervalHourFrequency,
        updateTillDate
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, _, variables) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, variables.briefId],
      });
    },
  });

  return {
    attachReport,
    isAttaching,
    isAttached,
    variables,
  };
}
